import React from "react";
import { Check, X, ShieldAlert } from "lucide-react";

export default function SaasComparison() {
  const comparisonRows = [
    {
      feature: "24/7 AI Tutor Assistant",
      traditional: false,
      skillzy: true,
      desc: "Skillzy integrates adaptive LLM tutors that answer course questions in real time."
    },
    {
      feature: "AI Exam Generator",
      traditional: false,
      skillzy: true,
      desc: "Generate chapter quizzes and competitive mock sheets matching custom syllabus rules."
    },
    {
      feature: "Subjective Digital Answer Sheets",
      traditional: false,
      skillzy: true,
      desc: "Full stylus drawing compatibility, PDF exports, and hybrid AI teacher evaluations."
    },
    {
      feature: "100% White-Label LMS",
      traditional: "Limited / Paid Addon",
      skillzy: true,
      desc: "Deploy client spaces under your root domain and logo branding settings."
    },
    {
      feature: "Multi-Tenant SaaS isolation",
      traditional: false,
      skillzy: true,
      desc: "Isolate student data, database tables, and system roles for security compliance."
    },
    {
      feature: "Placement & Resume Prep",
      traditional: false,
      skillzy: true,
      desc: "Built-in aptitude mocks, automated resume checkers, and AI mock interviews."
    },
    {
      feature: "Predictive Analytics",
      traditional: "Basic CSV reports",
      skillzy: "Advanced + AI Predictions",
      desc: "Forecast dropout warnings and course failures using cognitive metrics logs."
    }
  ];

  return (
    <section className="py-24 bg-slate-50 dark:bg-slate-900 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 dark:text-white tracking-tight">
            How Skillzy Compares
          </h2>
          <p className="mt-4 text-lg text-slate-600 dark:text-slate-300 font-medium">
            Discover why modern institutions are replacing legacy, clunky systems with our AI-powered, multi-tenant learning infrastructure.
          </p>
        </div>

        {/* Comparison Table */}
        <div className="max-w-4xl mx-auto bg-white dark:bg-slate-950 rounded-[2.5rem] border border-slate-100 dark:border-slate-800 shadow-xl overflow-hidden">
          
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="border-b border-slate-150 dark:border-slate-800 bg-slate-50 dark:bg-slate-900/50">
                  <th className="py-6 px-8 text-xs font-black uppercase text-slate-400">Pillars</th>
                  <th className="py-6 px-6 text-xs font-black uppercase text-slate-400 text-center">Traditional LMS</th>
                  <th className="py-6 px-6 text-xs font-black uppercase text-slate-900 dark:text-white text-center bg-violet-500/5 dark:bg-violet-500/10">
                    Skillzy LMS
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
                {comparisonRows.map((row) => (
                  <tr key={row.feature} className="hover:bg-slate-50/50 dark:hover:bg-slate-900/20 transition-colors">
                    
                    {/* Feature & description */}
                    <td className="py-6 px-8 max-w-md">
                      <p className="text-sm font-black text-slate-900 dark:text-white">{row.feature}</p>
                      <p className="text-xs text-slate-450 dark:text-slate-500 mt-1">{row.desc}</p>
                    </td>

                    {/* Traditional column */}
                    <td className="py-6 px-6 text-center text-xs font-semibold text-slate-400">
                      {row.traditional === false ? (
                        <div className="flex justify-center text-rose-500">
                          <X size={18} />
                        </div>
                      ) : (
                        row.traditional
                      )}
                    </td>

                    {/* Skillzy Column */}
                    <td className="py-6 px-6 text-center text-xs font-extrabold text-violet-600 dark:text-violet-400 bg-violet-500/5 dark:bg-violet-500/10">
                      {row.skillzy === true ? (
                        <div className="flex justify-center text-violet-600 dark:text-violet-400">
                          <Check size={18} strokeWidth={3} />
                        </div>
                      ) : (
                        row.skillzy
                      )}
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>

        </div>

      </div>
    </section>
  );
}
